import React, {Fragment, memo} from 'react';
import {useSelector} from 'react-redux';

import {viewSelector} from '@mapsight/ui/src/js/store/selectors';
import {VIEW_DESKTOP, VIEW_MOBILE} from '@mapsight/ui/src/js/config/constants/app';

import {memoForever} from '../../modules/helpers';


import {useNavPos} from '../../hooks';
import {isViewWithMapWidget} from '../store/selectors';

import Link from '../../stade/components/link';

import AudioPlayer from '../../stade/components/audio-player';
import RatingWidget from '../../stade/components/rating-widget';
import NaviWidget from '../../stade/components/navi-widget';
import PoiCycling from '../../stade/components/poi-cycling';


/** @type {import("@mapsight/ui/src/js/components/contexts").MapWrapper} */
const MapWrapper = memo(function MapWrapper({children}) {
		const navPos = useNavPos();
		const view = useSelector(viewSelector);
		const widget = isViewWithMapWidget(view); // TODO Stade: Formel ist falsch, zusätzlich entscheiden über useNavPos

		let content=children;

		if(widget) {
			content = (
				<div className="stade-widget__map stade-widget stade-widget--with-bg">
					<Link to={`${(navPos.app?.lang === 'en'?'/map':'/karte')}`} >
						{content}
					</Link>
					<PoiCycling />
				</div>
			);
		}

		if(view === VIEW_DESKTOP) {
			content=(<Fragment>
				<NaviWidget />
				<RatingWidget />
				{navPos.deepLink && <AudioPlayer />}
				{content}
			</Fragment>);
		}

		return (
			<div className="ms3-flex ms3-flex--column ms3-map-wrapper">
				{content}
			</div>
		);
	},
	memoForever
);

export default MapWrapper;
